import Blob from 'blob';

const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
  {
    name: 'Name',
    value: 'candidateName',
  },
  {
    name: 'Gender',
    value: 'gender',
  },
  {
    name: 'Email',
    value: 'primaryEmail',
  },
  {
    name: 'Contact',
    value: 'primaryContact',
  },
  {
    name: 'Roll No',
    value: 'universityRollNo',
  },
  {
    name: 'College Name',
    value: 'collegeName',
  },
  {
    name: 'Colleg State',
    value: 'stateName',
  },
  {
    name: 'Graduation Marks',
    value: 'marksGraduation',
  },
  {
    name: 'Graduation YOP',
    value: 'yopGraduation',
  },
  {
    name: 'Branch',
    value: 'stream',
  },
  {
    name: 'Degree',
    value: 'degree',
  },
  {
    name: 'Backlogs',
    value: 'backlogs',
  },
  {
    name: 'Placement Status',
    value: 'placementStatus',
  },
  {
    name: '10th Marks',
    value: 'marks10',
  },
  {
    name: 'Year of Passing',
    value: 'yop10',
  },
  {
    name: '12th Marks',
    value: 'marks12',
  },
  {
    name: 'Year of Passing',
    value: 'yop12',
  },
  {
    name: 'DOB',
    value: 'dateOfBirth',
  },
  {
    name: 'Time',
    value: 'time',
  },
];

const allCandidates = (JSONData, fileName = 'Registrations') => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let csv = '';
  let row = '';
  labels.forEach((fieldName) => {
    row += `${fieldName.name},`;
  });
  row = row.slice(0, -1);
  csv += `${row}\r\n`;
  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
    // eslint-disable-next-line
    labels.forEach(fieldName => {
      const { value } = fieldName;

      if (value === 'index') {
        row += `${i + 1},`;
      } else {
        const arrValue =
          typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      }
    });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }

  if (csv === '') {
    return;
  }

  // const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const uri = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  const csvUrl = URL.createObjectURL(uri);
  // link.href = uri;
  link.href = csvUrl;
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// var csvUrl = URL.createObjectURL(csvData);
// a.href =  csvUrl;

export default allCandidates;



// WEBPACK FOOTER //
// ./src/utils/AllCandidateCSV.js